
export function getMenu (ctx, data) {
  let type = data.type

  if(data.role === 'superadmin') {
    type = 'superadmin'
  }

  ctx.commit('setMenu', type)
}